import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loggedInState: false,
  user: null,
  sessionRevoked: false,
};

const saveCredentials = (data = {}) => {
  if (data.token) localStorage.setItem("token", data.token);
  if (data.sessionId) localStorage.setItem("sessionId", data.sessionId);
};

const clearCredentials = () => {
  localStorage.removeItem("token");
  localStorage.removeItem("sessionId");
  localStorage.removeItem("isLoggedIn");
};

const userSlice = createSlice({

  name: "user",
  initialState,
  reducers: {
    authPending: (state, action) => {
      state.user = action.payload || null;
      state.sessionRevoked = false;
    },
    authenticated: (state, action) => {
      state.loggedInState = true;
      state.user = action.payload;
      state.sessionRevoked = false;
    },
    loggedOut: () => initialState,
    sessionRevoked: () => ({ ...initialState, sessionRevoked: true }),
    clearSessionRevoked: (state) => {
      state.sessionRevoked = false;
    },
  },
});

const {
  authPending,
  authenticated,
  loggedOut,
  sessionRevoked,
  clearSessionRevoked,
} = userSlice.actions;

export const beginAuth = (data) => (dispatch) => {
  saveCredentials(data);
  dispatch(authPending(data));
};

export const setAuthUser = (data) => (dispatch) => {
  if (!data) return;
  saveCredentials(data);
  localStorage.setItem("isLoggedIn", "true");
  dispatch(authenticated(data));
};

export const storeSessionId = (sessionId) => () => {
  if (sessionId) localStorage.setItem("sessionId", sessionId);
};

export const clearSessionId = () => () => {
  localStorage.removeItem("sessionId");
};

export const logout = () => (dispatch) => {
  clearCredentials();
  dispatch(loggedOut());
};

export const revokeSession = () => (dispatch) => {
  clearCredentials();
  dispatch(sessionRevoked());
};

export { clearSessionRevoked };
export default userSlice.reducer;
